import RadialBarChart from './RadialBarChart';

export default RadialBarChart;
export { RadialBarChart };
